import { APP_ROUTES } from "~/single-page/constants/routes";

export const NAVIGATION = [
  {
    kind: "header",
    title: "Voluntariado e doação",
  },
  {
    segment: APP_ROUTES.MOVING_ACTIONS,
    title: "Voluntariado e doação",
    icon: "charity",
  },
  {
    kind: "divider",
  },
  {
    segment: APP_ROUTES.FIND_YOUR_CAUSE,
    title: "Conheça ONGs e Projetos",
    icon: "charity",
  },
  {
    kind: "divider",
  },
  {
    segment: APP_ROUTES.SPONSORS_COMPANIES,
    title: "Empresas Parceiras",
    icon: "charity",
  },
  {
    kind: "divider",
  },
  {
    segment: APP_ROUTES.FOOD_BANK,
    title: "Banco de alimentos",
    icon: "charity",
  },
  {
    kind: "divider",
  },
  {
    segment: APP_ROUTES.PARTNERS,
    title: "Rede institucional",
    icon: "ong",
  },
  {
    kind: "header",
    title: "Doação de sangue",
  },
  {
    segment: APP_ROUTES.BLOOD_DONATIONS,
    title: "Quem pode doar",
    icon: "blood",
  },
  {
    kind: "divider",
  },
  {
    segment: `${APP_ROUTES.BLOOD_DONATIONS}#blood-banks`,
    title: "Bancos de Sangue",
    icon: "blood",
  },
  {
    kind: "divider",
  },
  {
    kind: "header",
    title: "Doação de órgãos",
  },
  {
    segment: APP_ROUTES.ORGAN_DONOR,
    title: "Seja um doador",
    icon: "realheart",
  },
  {
    kind: "header",
    title: "Imposto de Renda",
  },
  {
    segment: `${APP_ROUTES.INCOME_TAX}#how-to-donate`,
    title: "Como doar",
    icon: "monetization",
  },
  {
    kind: "divider",
  },
  {
    segment: `${APP_ROUTES.INCOME_TAX}#to-whom-to-donate`,
    title: "Pra quem doar",
    icon: "monetization",
  },
  {
    kind: "divider",
  },
  {
    segment: `${APP_ROUTES.INCOME_TAX}#donate-in-the-declaration`,
    title: "Doar na declaração",
    icon: "monetization",
  },
  {
    kind: "header",
    title: "Área da ONG",
  },
  {
    segment: APP_ROUTES.KNOWLEDGE_TRAILS,
    title: "Trilha de capacitação",
    icon: "ong",
  },
  {
    kind: "divider",
  },
  {
    segment: APP_ROUTES.ACTIVE_NOTICES,
    title: "Editais",
    icon: "ong",
  },
  {
    kind: "divider",
  },
  {
    kind: "header",
    title: "Eventos que fazem o bem",
  },
  {
    segment: APP_ROUTES.EVENTS,
    title: "Agenda",
    icon: "calendar",
  },
];
